import useRole from '~/store/user/hooks/useRole';

import { IUseGetEditClientAllocationsParams, IUseGetEditClientAllocationsResult } from '../types';
import useGetEditClientAllocationsForActTeamMember from './useGetEditClientAllocationsForActTeamMember';
import useGetEditClientAllocationsForGlobalUser from './useGetEditClientAllocationsForGlobalUser';
import useGetEditClientAllocationsForTeamAdmin from './useGetEditClientAllocationsForTeamAdmin';

const useGetEditClientAllocations = (
  params: IUseGetEditClientAllocationsParams,
): IUseGetEditClientAllocationsResult => {
  const { isGlobalUser, isActTeamMember } = useRole();
  // LocalAdmin and other roles
  const isTeamAdmin = !isGlobalUser && !isActTeamMember;

  const globalUserResult = useGetEditClientAllocationsForGlobalUser({
    ...params,
    enabled: params.enabled ?? isGlobalUser,
  });

  const actTeamMemberResult = useGetEditClientAllocationsForActTeamMember({
    ...params,
    enabled: params.enabled ?? isActTeamMember,
  });

  const teamAdminResult = useGetEditClientAllocationsForTeamAdmin({
    ...params,
    enabled: params.enabled ?? isTeamAdmin,
  });

  if (isGlobalUser) {
    return globalUserResult;
  }

  if (isActTeamMember) {
    return actTeamMemberResult;
  }

  return teamAdminResult;
};

export default useGetEditClientAllocations;
